<template>
  <MobileHeader
    :mobileHeaderTitle="'FANTASY_SPORT'"
    :tabs="$route.name"
  ></MobileHeader>

  <div class="container has-space has-header">
    <h1 class="page-title" v-if="!isMobile">{{ $t("FANTASY_SPORT") }}</h1>
    <div class="content">
      <div class="coming-soon">
        <div class="coming-soon__image">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="169"
            height="152"
            viewBox="0 0 169 152"
            fill="none"
          >
            <g clip-path="url(#clip0_15420_63199)">
              <path
                d="M160.263 140.767V140.933C160.263 140.977 160.263 141.022 160.26 141.066C160.218 143.327 159.429 145.51 158.015 147.276C157.944 147.368 157.869 147.457 157.792 147.546C157.677 147.682 157.559 147.813 157.437 147.942C157.426 147.952 157.416 147.965 157.403 147.975L157.398 147.98C157.384 147.994 157.37 148.01 157.356 148.024C157.142 148.245 156.917 148.458 156.682 148.661C156.635 148.701 156.586 148.743 156.535 148.783C154.715 150.295 152.427 151.131 150.061 151.148C150.044 151.15 150.024 151.15 150.007 151.15H149.946C149.928 151.15 149.911 151.15 149.894 151.148C149.833 151.148 149.773 151.146 149.712 151.145C147.345 151.089 145.071 150.214 143.276 148.669C143.228 148.629 143.179 148.587 143.132 148.544C142.945 148.38 142.766 148.207 142.593 148.029C142.579 148.015 142.565 147.999 142.551 147.986L142.546 147.98C142.534 147.97 142.523 147.958 142.513 147.947C142.366 147.794 142.225 147.635 142.089 147.473C142.014 147.384 141.941 147.293 141.869 147.201C140.492 145.448 139.725 143.294 139.685 141.066C139.681 141.024 139.681 140.98 139.681 140.936V140.774C139.681 140.755 139.681 140.736 139.683 140.717C139.708 138.484 140.461 136.32 141.829 134.556C141.901 134.463 141.974 134.372 142.049 134.283C142.187 134.116 142.331 133.954 142.48 133.795C142.49 133.783 142.501 133.772 142.513 133.76C142.513 133.758 142.514 133.757 142.516 133.755C142.53 133.741 142.544 133.725 142.56 133.711C142.753 133.511 142.955 133.318 143.165 133.132C143.212 133.088 143.261 133.047 143.31 133.006C145.145 131.443 147.472 130.576 149.883 130.559C149.901 130.557 149.92 130.557 149.937 130.557H150.05C152.406 130.572 154.684 131.398 156.502 132.895C156.551 132.937 156.6 132.977 156.648 133.019C156.903 133.235 157.147 133.465 157.379 133.706C157.393 133.72 157.407 133.736 157.421 133.75L157.424 133.753C157.437 133.764 157.449 133.778 157.459 133.788C157.588 133.924 157.712 134.065 157.832 134.208C157.909 134.297 157.982 134.386 158.056 134.479C159.461 136.256 160.236 138.45 160.261 140.717C160.263 140.733 160.263 140.75 160.263 140.767Z"
                fill="#01C3F7"
              />
              <path
                d="M150.061 130.599H149.712V151.183H150.061V130.599Z"
                fill="white"
              />
              <path
                d="M160.263 140.717H139.599V141.066H160.263V140.717Z"
                fill="white"
              />
              <path
                d="M145.524 140.717C145.497 139.445 145.167 138.199 144.563 137.08C143.959 135.962 143.097 135.003 142.049 134.283C141.974 134.372 141.901 134.463 141.829 134.556C142.837 135.242 143.666 136.159 144.248 137.231C144.831 138.302 145.149 139.497 145.177 140.717C145.179 140.774 145.179 140.832 145.179 140.891C145.179 140.95 145.179 141.008 145.177 141.066C145.149 142.277 144.834 143.464 144.259 144.53C143.685 145.597 142.866 146.512 141.869 147.201C141.941 147.293 142.014 147.384 142.089 147.473C143.126 146.751 143.977 145.795 144.574 144.681C145.171 143.568 145.497 142.329 145.524 141.066C145.528 141.008 145.528 140.949 145.528 140.891C145.528 140.834 145.528 140.774 145.524 140.717Z"
                fill="white"
              />
              <path
                d="M154.596 141.066C154.594 141.008 154.594 140.95 154.594 140.891C154.594 140.832 154.594 140.774 154.596 140.717C154.625 139.474 154.955 138.258 155.557 137.171C156.16 136.085 157.017 135.161 158.056 134.479C157.982 134.386 157.909 134.297 157.832 134.208C156.755 134.923 155.866 135.889 155.242 137.022C154.618 138.156 154.277 139.423 154.249 140.717C154.246 140.774 154.246 140.834 154.246 140.891C154.246 140.949 154.246 141.008 154.249 141.066C154.277 142.351 154.613 143.611 155.23 144.738C155.847 145.866 156.726 146.829 157.792 147.546C157.869 147.457 157.944 147.368 158.015 147.276C156.988 146.592 156.141 145.671 155.546 144.589C154.951 143.508 154.625 142.299 154.596 141.066Z"
                fill="white"
              />
              <path
                d="M168.5 151.085H0.5V151.476H168.5V151.085Z"
                fill="#2F2E41"
              />
              <path
                d="M158.864 72.9688C158.898 91.5741 151.761 109.476 138.94 122.953C138.853 123.046 138.764 123.138 138.675 123.23C131.908 130.288 123.786 135.904 114.795 139.741C105.805 143.579 96.1315 145.559 86.3567 145.563C76.5819 145.567 66.9073 143.594 57.9137 139.763C48.9202 135.932 40.7934 130.323 34.0215 123.271C33.9325 123.178 33.8435 123.086 33.7563 122.993C20.9805 109.548 13.837 91.7181 13.7935 73.1671C13.7501 54.6161 20.81 36.753 33.5228 23.2478C33.6082 23.1536 33.6971 23.0611 33.786 22.9686C40.5579 15.8503 48.7044 10.1821 57.7316 6.30786C66.7587 2.4336 76.4783 0.433951 86.3011 0.430181C96.1238 0.426412 105.845 2.4186 114.875 6.28593C123.905 10.1533 132.056 15.8152 138.833 22.9283C138.922 23.0207 139.011 23.1131 139.097 23.2073C151.809 36.6524 158.884 54.462 158.864 72.9688Z"
                fill="#212B30"
              />
              <path
                d="M158.864 72.8221H13.7934V73.171H158.864V72.8221Z"
                fill="white"
              />
              <path
                d="M86.5033 0.430176H86.1545V145.563H86.5033V0.430176Z"
                fill="white"
              />
              <path
                d="M54.6029 49.0793C51.4933 41.7222 46.9855 35.039 41.3297 29.4007C38.9904 27.0591 36.4677 24.9082 33.786 22.9686C33.6971 23.0611 33.6082 23.1536 33.5228 23.2478C49.0158 34.4338 59.1203 52.6483 59.1281 73.1815C59.136 93.6274 49.1309 111.783 33.7563 122.993C33.8435 123.086 33.9325 123.178 34.0214 123.271C36.6283 121.366 39.083 119.262 41.3633 116.976C50.0652 108.256 55.9723 97.1404 58.3305 85.047C60.6886 72.9536 59.3909 60.4315 54.6029 49.0793Z"
                fill="white"
              />
              <path
                d="M113.53 73.1606C113.522 52.6274 123.612 34.4052 139.097 23.2073C139.011 23.1131 138.922 23.0207 138.833 22.9283C130.911 28.6646 124.459 36.1955 120.005 44.9051C115.551 53.6147 113.22 63.2555 113.205 73.039C113.189 82.8224 115.489 92.4705 119.916 101.194C124.343 109.918 130.771 117.469 138.675 123.23C138.764 123.138 138.853 123.045 138.94 122.953C123.558 111.755 113.538 93.6065 113.53 73.1606Z"
                fill="white"
              />
              <path
                d="M68.6686 123.308L68.1854 132.976L73.2586 133.943L74.7081 124.759L68.6686 123.308Z"
                fill="#9D616A"
              />
              <path
                d="M93.7929 126.45L95.0009 134.426H99.5909L98.6246 125.967L93.7929 126.45Z"
                fill="#9D616A"
              />
              <path
                d="M69.6349 104.699L68.6686 115.816L67.7022 125.242C67.7022 125.242 71.326 123.792 74.7081 125.967C74.7081 125.967 76.8823 125.484 76.3992 116.058L78.5734 106.149L69.6349 104.699Z"
                fill="#EFEFEF"
              />
              <path
                d="M89.203 108.324C89.203 108.324 90.6525 117.025 91.3772 117.75C91.3772 117.75 92.5737 125.53 93.1549 127.497C93.1897 127.637 93.2418 127.773 93.3098 127.9C93.793 128.626 99.1078 130.317 99.3494 127.417C99.591 124.517 100.316 119.683 97.8999 116.058L96.4504 106.874L89.203 108.324Z"
                fill="#EFEFEF"
              />
              <path
                d="M103.819 107.236C103.577 109.895 90.2901 109.412 87.8743 109.412C87.1108 109.412 86.1301 109.293 85.642 107.974C84.8061 105.719 84.3472 102.425 84.1925 101.136C84.1297 102.33 83.5789 105.221 82.2019 107.072C81.3636 108.203 79.977 107.978 78.4526 107.72C75.9208 107.29 70.8887 105.724 69.5141 106.028C67.3399 106.511 64.7235 106.56 64.6825 106.028C64.6637 105.737 64.6653 105.446 64.6873 105.156C65.0062 100.158 69.6349 86.6087 69.6349 85.6058C69.6349 84.3973 71.8091 79.322 71.8091 79.322L94.0346 76.6635C94.0346 76.6635 102.838 100.421 104.048 106.27C104.152 106.775 103.838 107.026 103.819 107.236Z"
                fill="#EFEFEF"
              />
              <path
                d="M73.9834 132.734L67.7022 131.526L68.3062 141.556L73.2586 145.06C73.2586 145.06 72.7754 135.393 73.9834 132.734Z"
                fill="#EFEFEF"
              />
              <path
                d="M99.591 132.009C99.591 132.009 96.4504 133.943 93.793 132.009L95.9672 140.951L99.591 140.468C99.591 140.468 101.282 135.151 99.591 132.009Z"
                fill="#EFEFEF"
              />
              <path
                d="M100.316 139.501C100.316 139.501 95.2425 139.743 95.2425 140.226V148.202C95.2425 148.927 96.2088 149.894 95.9672 150.377C95.7257 150.86 97.4167 152.069 101.282 151.344C105.147 150.619 103.698 148.202 103.698 148.202C103.698 148.202 99.8325 141.435 100.316 139.501Z"
                fill="#2F2E41"
              />
              <path
                d="M67.5814 139.622C67.5814 139.622 73.3794 139.743 73.3794 140.226V148.202C73.3794 148.927 72.4131 149.894 72.6546 150.377C72.8962 150.86 71.2052 152.069 67.3399 151.344C63.4746 150.619 64.924 148.202 64.924 148.202C64.924 148.202 68.0646 141.556 67.5814 139.622Z"
                fill="#2F2E41"
              />
              <path
                d="M104.181 107.357C103.939 110.016 89.9277 110.258 87.5119 110.258C86.7485 110.258 86.1301 109.293 85.642 107.974C88.2343 107.459 99.3832 105.359 104.048 106.27C104.137 106.625 104.182 106.991 104.181 107.357Z"
                fill="#01C3F7"
              />
              <path
                d="M82.202 107.072C81.3636 108.203 80.2186 108.945 78.6942 108.687C76.1624 108.256 70.8887 107.174 69.5141 107.478C67.3399 107.962 64.7235 106.56 64.6825 106.028C64.6637 105.737 64.6653 105.446 64.6873 105.156C69.7726 105.018 78.7788 105.078 82.202 107.072Z"
                fill="#01C3F7"
              />
              <path
                d="M72.7755 47.4197C72.7755 47.4197 68.427 45.9696 64.5617 50.3199L63.837 51.77C63.837 51.77 58.2806 53.4618 56.5895 54.6703C56.5895 54.6703 51.5163 53.4618 45.2352 54.6703L38.9541 53.2201C38.9541 53.2201 26.875 44.7612 25.6671 50.0782C24.4592 55.3953 37.0215 57.3288 37.0215 57.3288L47.4094 60.229C47.4094 60.229 55.3816 62.1624 58.5222 60.7123C58.5222 60.7123 67.4607 60.229 69.1517 56.8454L72.7755 58.5372V47.4197Z"
                fill="#9D616A"
              />
              <path
                d="M87.7535 46.2113C87.7535 46.2113 96.692 45.2446 100.074 49.8366L107.08 51.77C107.08 51.77 114.811 50.3199 117.71 51.045L123.991 49.3532C123.991 49.3532 130.03 39.6858 133.412 42.3444C136.794 45.0029 125.44 53.4618 125.44 53.4618L110.221 58.5372C110.221 58.5372 98.383 59.5039 95.9672 55.1536L93.3098 61.1957L83.1634 58.7789L87.7535 46.2113Z"
                fill="#9D616A"
              />
              <path
                d="M79.2981 45.0029C82.9005 45.0029 85.8208 42.0813 85.8208 38.4774C85.8208 34.8735 82.9005 31.9519 79.2981 31.9519C75.6958 31.9519 72.7755 34.8735 72.7755 38.4774C72.7755 42.0813 75.6958 45.0029 79.2981 45.0029Z"
                fill="#9D616A"
              />
              <path
                d="M75.916 42.3443V47.6614L78.3318 56.1203L85.5793 47.6614C85.5793 47.6614 83.6466 41.861 83.6466 40.8942C83.6466 39.9275 75.916 42.3443 75.916 42.3443Z"
                fill="#9D616A"
              />
              <path
                d="M95.1217 77.2677C95.1217 77.2677 95.0033 78.1401 93.9041 78.2199C91.7033 78.3818 87.9974 78.7564 85.5792 79.5637C81.9555 80.7721 71.0844 80.7721 71.0844 80.7721L70.379 58.8803L70.722 57.2079C70.4804 55.2744 72.4131 47.5405 72.4131 47.5405L73.8239 46.4989L75.1454 46.2137L75.5536 46.5738C75.5536 49.793 78.6942 52.8576 78.6942 52.8576C83.2842 50.6824 85.2169 45.8488 85.2169 45.8488L86.577 45.6482L87.9999 45.8077L89.2875 45.9527L88.8406 46.3321L88.599 46.8155C88.5845 46.8445 88.611 46.7865 88.599 46.8155C85.0816 54.2811 89.3286 57.6575 91.9812 59.1414C93.0804 59.7601 93.1891 60.3498 93.1891 60.3498C93.1891 60.3498 94.1819 60.0525 94.1554 61.0748C94.0756 64.3835 93.4742 71.8539 94.397 73.8841C95.6049 76.5426 95.1217 77.2677 95.1217 77.2677Z"
                fill="#EFEFEF"
              />
              <path
                d="M72.4131 34.0659C72.5694 33.5297 72.7533 33.0018 72.9639 32.4845C73.2393 31.852 72.9639 29.9543 73.2393 29.9543H74.3409L75.7179 28.6892L76.5441 29.3218L77.6457 28.6892L79.0227 29.3218L80.3997 28.6892L82.603 30.2706L83.1538 29.9543L83.7046 30.9031H83.98L85.0816 32.4845H85.6324V34.0659H86.1832V38.1775L85.4585 41.0151L85.2169 39.6228C85.2169 39.6038 85.2107 39.5853 85.1994 39.5701C85.188 39.5549 85.172 39.5437 85.1538 39.5384C85.1355 39.533 85.1161 39.5337 85.0983 39.5404C85.0805 39.547 85.0653 39.5592 85.0551 39.5752L84.5308 40.3914L84.1944 39.1038C83.7102 37.1753 82.5735 35.474 80.9775 34.289C78.9394 32.8095 75.9933 32.105 72.9639 36.2798L72.4131 34.0659Z"
                fill="#2F2E41"
              />
              <path
                d="M73.8239 46.4989C73.3649 49.2903 71.9783 57.0097 70.379 58.8804L70.3596 58.2955C70.1181 56.362 71.8091 46.9363 71.8091 46.9363L73.8239 46.4989Z"
                fill="#01C3F7"
              />
              <path
                d="M86.577 45.6482C85.3642 47.9393 81.8903 53.8533 78.5734 53.4618C75.3725 53.0848 75.1067 48.3043 75.1454 46.2137L75.916 46.047C75.916 49.2662 78.815 52.0117 78.815 52.0117C83.405 49.8366 84.8665 45.4572 84.8665 45.4572L86.577 45.6482Z"
                fill="#01C3F7"
              />
              <path
                d="M94.5178 59.5039C94.5178 59.5039 94.4912 60.1516 94.4647 61.1739C93.7924 61.1377 93.1255 61.0341 92.474 60.8646C85.0115 58.8949 87.1931 48.7562 87.9999 45.8077L89.2875 45.9527H89.2899C89.3261 45.9865 89.3648 46.0228 89.4035 46.059C85.8861 53.5246 89.8987 57.1547 92.5512 58.6387C93.1741 58.9962 93.8333 59.2863 94.5178 59.5039Z"
                fill="#01C3F7"
              />
              <path
                d="M95.7257 78.1136C95.7257 78.1136 95.0033 78.1402 93.9041 78.2199C93.3528 76.196 92.9125 74.1435 92.5851 72.0715C92.2663 69.8383 92.3677 64.3449 92.474 60.8646C92.503 59.9534 92.5296 59.1776 92.5513 58.6387C93.1741 58.9963 93.8333 59.2863 94.5178 59.5039C94.5178 59.5039 94.4912 60.1516 94.4647 61.1739C94.3849 64.4826 94.3197 71.7331 95.2425 73.7633C96.4504 76.4218 95.7257 78.1136 95.7257 78.1136Z"
                fill="#01C3F7"
              />
              <path
                d="M73.1378 61.5395C73.1378 61.5395 80.8684 57.8392 88.3574 61.5395H73.1378Z"
                fill="#01C3F7"
              />
              <path
                d="M71.5079 80.8463C71.5079 80.8463 73.7747 80.6719 79.3543 81.1952C84.934 81.7185 94.1753 78.2297 94.1753 78.2297"
                fill="#CACACA"
              />
              <path
                d="M40.9979 41.8606V42.0264C40.9979 42.07 40.9979 42.1153 40.9944 42.1589C40.9525 44.4201 40.1634 46.6037 38.7503 48.3689C38.6788 48.4614 38.6038 48.5504 38.5271 48.6393C38.412 48.7754 38.2935 48.9062 38.1714 49.0353C38.161 49.0458 38.1505 49.058 38.1383 49.0684L38.1331 49.0737C38.1191 49.0876 38.1051 49.1033 38.0912 49.1173C37.8767 49.3388 37.6518 49.551 37.4164 49.754C37.3693 49.7941 37.3205 49.836 37.2699 49.8761C35.4495 51.3885 33.1621 52.2242 30.7958 52.2415C30.7784 52.2432 30.7592 52.2432 30.7417 52.2432H30.6807C30.6633 52.2432 30.6459 52.2432 30.6284 52.2415C30.5674 52.2415 30.5081 52.2397 30.4471 52.238C28.0803 52.182 25.8061 51.3073 24.0113 49.7627C23.9625 49.7226 23.9137 49.6807 23.8666 49.6371C23.68 49.4731 23.5004 49.3004 23.3278 49.1225C23.3139 49.1086 23.2999 49.0929 23.2859 49.0789L23.2807 49.0737C23.2685 49.0632 23.258 49.051 23.2476 49.0405C23.1011 48.887 22.9599 48.7283 22.8239 48.5661C22.7489 48.4771 22.6757 48.3864 22.6042 48.2939C21.227 46.5418 20.4598 44.3875 20.4194 42.1589C20.4159 42.1171 20.4159 42.0735 20.4159 42.0298V41.8676C20.4159 41.8484 20.4159 41.8292 20.4176 41.8101C20.4423 39.5771 21.1961 37.4135 22.5641 35.6489C22.6355 35.5564 22.7088 35.4657 22.7838 35.3768C22.9215 35.2093 23.0662 35.0471 23.2144 34.8883C23.2249 34.8761 23.2354 34.8657 23.2476 34.8534C23.2476 34.8517 23.2493 34.85 23.251 34.8482C23.265 34.8343 23.2789 34.8186 23.2946 34.8046C23.4882 34.604 23.6899 34.411 23.8997 34.2255C23.9468 34.1819 23.9956 34.14 24.0444 34.0999C25.8797 32.536 28.2073 31.6694 30.618 31.6525C30.6354 31.6508 30.6546 31.6508 30.672 31.6508H30.7853C33.1403 31.6655 35.4185 32.4909 37.2368 33.9882C37.2856 34.0301 37.3345 34.0702 37.3833 34.1121C37.6379 34.3284 37.882 34.5586 38.1139 34.7994C38.1278 34.8133 38.1418 34.829 38.1557 34.843L38.1592 34.8465C38.1714 34.8569 38.1836 34.8709 38.1941 34.8814C38.3231 35.0174 38.4469 35.1587 38.5672 35.3018C38.644 35.3907 38.7172 35.4797 38.7904 35.5721C40.1955 37.3499 40.9713 39.5438 40.9961 41.8101C40.9976 41.8269 40.9981 41.8438 40.9979 41.8606Z"
                fill="#01C3F7"
              />
              <path
                d="M30.7958 31.6926H30.4471V52.2764H30.7958V31.6926Z"
                fill="white"
              />
              <path
                d="M40.9979 41.8101H20.3339V42.1589H40.9979V41.8101Z"
                fill="white"
              />
              <path
                d="M26.2588 41.8101C26.2315 40.5388 25.902 39.2923 25.2978 38.1736C24.6935 37.055 23.8317 36.0963 22.7838 35.3768C22.7088 35.4657 22.6356 35.5564 22.5641 35.6489C23.5716 36.3355 24.4009 37.2527 24.9832 38.3242C25.5654 39.3957 25.8838 40.5908 25.9119 41.8101C25.9136 41.8676 25.9136 41.9252 25.9136 41.9845C25.9136 42.0438 25.9136 42.1014 25.9119 42.1589C25.8836 43.3701 25.5691 44.5574 24.9942 45.6237C24.4193 46.69 23.6003 47.605 22.6042 48.2939C22.6756 48.3864 22.7489 48.4771 22.8239 48.5661C23.8606 47.8444 24.7121 46.8879 25.3091 45.7744C25.906 44.661 26.2315 43.4221 26.2588 42.1589C26.2623 42.1014 26.2623 42.0421 26.2623 41.9845C26.2623 41.9269 26.2623 41.8676 26.2588 41.8101Z"
                fill="white"
              />
              <path
                d="M35.331 42.1589C35.3293 42.1014 35.3293 42.0438 35.3293 41.9845C35.3293 41.9252 35.3293 41.8676 35.331 41.8101C35.3598 40.5678 35.6897 39.3511 36.2922 38.2646C36.8948 37.178 37.7521 36.2541 38.7904 35.5721C38.7172 35.4797 38.6439 35.3907 38.5672 35.3018C37.4894 36.0169 36.6005 36.9823 35.9766 38.1156C35.3526 39.2489 35.0121 40.5165 34.984 41.8101C34.9805 41.8676 34.9805 41.9269 34.9805 41.9845C34.9805 42.0421 34.9805 42.1014 34.984 42.1589C35.0119 43.4442 35.3483 44.7039 35.965 45.8318C36.5816 46.9596 37.4604 47.9226 38.5271 48.6393C38.6038 48.5504 38.6788 48.4614 38.7503 48.3689C37.7231 47.6853 36.8759 46.7639 36.2806 45.6828C35.6854 44.6017 35.3596 43.3929 35.331 42.1589Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_15420_63199">
                <rect
                  width="168"
                  height="151.14"
                  fill="white"
                  transform="translate(0.5 0.430115)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div class="coming-soon__text">
          {{ $t("FANTASY_BASKETBALL_IS_COMING_TO_ASPN") }}
        </div>
      </div>
    </div>

    <!-- <div>
        <iframe class="fantasy-iframe" :src=fantacyIframeUrl></iframe>
    </div> -->
  </div>
</template>

<script>
import MobileHeader from "@/components/mobile/Header.vue";
import { mapGetters, mapActions } from "vuex";
import config from "@/js/config.js";

export default {
  components: {
    MobileHeader,
  },
  data() {
    return {
      tabs: [
        {
          name: "MATCHES",
          pathName: "footballFavMatches",
          selected: true,
        },
        {
          name: "TEAMS",
          pathName: "footballFavTeams",
          selected: false,
        },
        {
          name: "COMPETITIONS",
          pathName: "footballFavCompetitions",
          selected: false,
        },
      ],
      currentTab: [],
      fantasySportUrl: config.fantasySportUrl,
      fantacyIframeUrl: "",
    };
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "isLogin",
      "currentLocale",
      "userSwitchCountryLang",
    ]),
  },
  watch: {
    isLogin: {
      deep: true,
      handler(newVal, oldVal) {
        if (!newVal) {
          this.$router.push({ name: "home" });
        }
      },
    },
    userSwitchCountryLang: {
      handler(newVal, oldVal) {
        location.reload();
      },
    },
  },
  mounted() {
    this.commonVerifyLogin();
    if (!this.isLogin) {
      location.href = `/${this.currentLocale}`;
    } else {
      this.getProviderTokenData();
    }
  },
  methods: {
    ...mapActions(["commonVerifyLogin", "getProviderToken"]),
    async getProviderTokenData() {
      let params = {
        providerId: 1,
      };
      const result = await this.getProviderToken(params);
      let token = result.result.data;

      this.fantacyIframeUrl = `${this.fantasySportUrl}/?token=${token}`;
    },
  },
};
</script>

<style scoped>
.coming-soon {
  position: relative;
  width: 20rem;
  height: auto;
  margin: 3rem auto;
}

.coming-soon__image {
  position: relative;
  width: 10.5rem;
  height: auto;
  margin: 0 auto;
  padding-bottom: 1rem;
}

.coming-soon__text {
  position: relative;
  width: 18.1875rem;
  height: auto;
  margin: 0 auto;
  text-align: center;

  font-size: 1.375rem;
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 1.625rem;
}

.fantasy-iframe {
  width: 100%;
  height: 1300px;
  border: none;
  margin-top: 1rem;
}
.fantasy-iframe-logout {
  height: 0;
  border: none;
}
@media(max-width: 768px) { /* for test */
}
</style>
